/**
 * Service for fetching average age data from the backend API
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';

/**
 * Fetch average age data from the backend
 */
export const getAverageAgeData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/external-data/avg-age`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching average age data:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Format average age data for use in components
 */
export const formatAverageAgeData = (apiData) => {
  if (!apiData) {
    return null;
  }

  let ageValue;
  
  // Check if it's the InsightDB Value Matrix API response format
  if (apiData.responseCode === 200 && apiData.data && Array.isArray(apiData.data) && apiData.data.length > 0) {
    // Get the first item since we know the API returns [{"avgAge":"31"}]
    const firstItem = apiData.data[0];
    if (firstItem && firstItem.avgAge !== undefined) {
      ageValue = firstItem.avgAge;
    }
  }
  // Handle fallback API response format
  else if (typeof apiData === 'object') {
    ageValue = apiData.avg_age || apiData.age || apiData.average_age;
  } else if (typeof apiData === 'string' || typeof apiData === 'number') {
    ageValue = apiData;
  }

  // Ensure we have a valid age value
  if (ageValue === undefined || ageValue === null) {
    return null;
  }

  // Convert to string and ensure it's a number
  const ageStr = ageValue.toString();
  const numericValue = typeof ageValue === 'number' 
    ? ageValue 
    : parseFloat(ageStr);

  return {
    age: ageStr,
    rawValue: numericValue,
    fallback: false
  };
};